import axios from "axios";
import authHeader from "./auth-header-login";

const API_URL = process.env.VUE_APP_ENDPOINT;

class UserService {
	/*
	 * Mi Perfil
	 */
	loadMe(id) {
		return axios.get(API_URL + `/users/me`, {
			headers: authHeader(),
		});
	}

	loadUserMe(id) {
		return axios.get(API_URL + `/users/${id}?populate[0]=role`, {
			headers: authHeader(),
		});
	}

	updateMyProfile(id, data) {
		return axios.put(API_URL + `/profiles/${id}`, data, {
			headers: authHeader(),
		});
	}
}

export default new UserService();
